.hoverInfoTrigger {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.hoverInfoAnchor {
  position: absolute;
  bottom: calc(100% + 6px);
  z-index: 200;
  padding-bottom: 6px;
  margin-bottom: -6px;
  pointer-events: auto;
}

.anchorEnd {
  inset-inline-end: 0;
}

.anchorStart {
  inset-inline-start: 0;
}

.peopleHoverCard {
  background-color: var(--contextMenuBg, rgb(30, 30, 30));
  color: var(--contextMenuText, white);
  border: 1px solid var(--contextMenuBorder, rgba(120, 120, 120, 0.3));
  border-radius: 7px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.3);
  padding: 4px;
  max-width: 260px;
  width: max-content;
  text-align: start;
  cursor: default;
  font-size: 12.5px;
  line-height: 1.2;
}

.peopleHoverTitle {
  font-weight: 600;
  font-size: 11px;
  opacity: 0.7;
  padding: 3px 6px 4px;
}

.peopleHoverList {
  display: flex;
  flex-direction: column;
}

.peopleHoverRow {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 3px 6px;
  border-radius: 5px;
}
.peopleHoverRow :global(.avatar) {
  flex-shrink: 0;
}

.peopleHoverName {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}

.peopleHoverDetail {
  flex-shrink: 0;
  opacity: 0.65;
  font-size: 11.5px;
  white-space: nowrap;
}

.peopleHoverEmpty {
  padding: 3px 6px;
  opacity: 0.7;
  font-size: 11.5px;
}